import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsToggle1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSettingsToggle1"><Path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 8.13401 4.13401 5 8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12ZM12.5 12C12.5 10.067 14.067 8.5 16 8.5C17.933 8.5 19.5 10.067 19.5 12C19.5 13.933 17.933 15.5 16 15.5C14.067 15.5 12.5 13.933 12.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsToggle1;
